/*
 * Module for the Withholdings/Index view
*/

rs.module("ui/content/benefits/withholdings/index",

    [ "controls/components/event-banner" ],

    function (eventBanner) {

        // Initialize the module
        function initialize(jsSelectors, backendUrls, filterOptions) {

            // Unpack js selectors
            var filterSelect = $.js(jsSelectors.filterSelect);
            var listSkeleton = $.js(jsSelectors.listSkeleton);
            var withholdings = $.js(jsSelectors.withholdings);

            // Update the list based on selected filter
            filterSelect.change(function () {

                eventBanner.removeAllMessages();
                listSkeleton.show();
                withholdings.hide();

                $.get(
                    backendUrls.getWithholdingListAsync,
                    {
                        viewAll: $(this).val() == filterOptions.all
                    })
                    .done(function (html) {
                        withholdings.html(html);
                    })
                    .always(function () {
                        listSkeleton.hide();
                        withholdings.show();
                    });
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);